import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { EditFundingRequestModel, FundingRequest } from '../../models/inModels/FundingRequest';

@Injectable()
export class FundingRequestService {

	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/funding/requests/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<FundingRequest> {
		return this.http.get(`${this.auth.apiUrl}/api/funding/requests/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as FundingRequest)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditFundingRequestModel): Promise<FundingRequest> {
		return this.http.post(`${this.auth.apiUrl}/api/funding/requests/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as FundingRequest)
			.catch(error => this.logging.handleError(error));
  }

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/funding/requests/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	approve(id: number): Promise<any> {
		console.log(id);
		return this.http.get(`${this.auth.apiUrl}/api/funding/requests/approve/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	disapprove(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/funding/requests/disapprove/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));

	}

	review(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/funding/requests/review/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));

	}

	feedback(user: EditFundingRequestModel): Promise<FundingRequest> {
		return this.http.post(`${this.auth.apiUrl}/api/funding/requests/feedback`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as FundingRequest)
			.catch(error => this.logging.handleError(error));
  }

	

	// feedback(user: EditFundingRequestModel): Promise<FundingRequest> {
	// 		return this.http.post(`${this.auth.apiUrl}/api/funding/requests/feedback`, JSON.stringify(user), { headers: this.auth.header })
	// 		.toPromise()
	// 		.then(response => response as FundingRequest)
	// 		.catch(error => this.logging.handleError(error));
	
	// 	}
	


}



// WEBPACK FOOTER //
// ./src/app/services/funding/funding-request.service.ts